import React from "react";

const FIELD_LABELS = {
  email: "Email (match key)", full_name: "Full name", staff_id_label: "Staff ID (match key)", job_title: "Job title",
  access_role: "Access role (suggestion only)", staff_classification: "Classification", home: "Home",
  gender: "Gender", phone: "Phone", active_status: "Status (ignored — never deactivates)",
};
const SEL = "px-2 py-1.5 rounded-md border border-slate-200 text-sm bg-white";

export const ImportMappingStep = ({ parsed, mapping, setMapping, aliases, setAliases, onBack, onNext, busy }) => {
  const used = new Set(Object.values(mapping).filter(Boolean));
  const hasEmail = used.has("email");
  return (
    <div className="space-y-5" data-testid="import-mapping-step">
      <div className="nv-card p-5 space-y-3">
        <h3 className="text-h3">Detected columns</h3>
        <p className="text-xs text-slate-500">File <b>{parsed.file_name}</b> · headers on row {parsed.header_row} · {parsed.row_count} data rows.
          {parsed.title_rows?.length > 0 && <> Skipped title rows: <i>{parsed.title_rows.join(" / ")}</i></>}</p>
        <table className="w-full text-sm" data-testid="import-mapping-table">
          <thead className="text-xs uppercase text-slate-500 text-left"><tr><th className="py-2 pr-3">Column in file</th><th className="py-2 pr-3">Sample</th><th className="py-2">Maps to</th></tr></thead>
          <tbody>
            {parsed.headers.map((h) => (
              <tr key={h} className="border-t border-slate-100" data-testid={`mapping-row-${h.replace(/\s+/g, "-")}`}>
                <td className="py-2 pr-3 font-medium text-slate-800">{h}</td>
                <td className="py-2 pr-3 text-xs text-slate-500">{parsed.sample.map((r) => r[h]).filter(Boolean).slice(0, 2).join(" · ") || "—"}</td>
                <td className="py-2">
                  <select value={mapping[h] || ""} onChange={(e) => setMapping({ ...mapping, [h]: e.target.value || null })} className={SEL} data-testid={`mapping-select-${h.replace(/\s+/g, "-")}`}>
                    <option value="">— ignore —</option>
                    {parsed.fields.map((f) => <option key={f} value={f} disabled={used.has(f) && mapping[h] !== f}>{FIELD_LABELS[f] || f}</option>)}
                  </select>
                  {parsed.ignored_hint.includes(h) && !mapping[h] && <span className="ml-2 text-[12.5px] text-slate-400">not a directory field — skipped</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!hasEmail && <p className="text-xs text-rose-700" data-testid="mapping-email-missing">Map an Email column to continue.</p>}
      </div>

      {parsed.file_homes.length > 0 && (
        <div className="nv-card p-5 space-y-3" data-testid="import-home-aliases">
          <h3 className="text-h3">Home names in the file</h3>
          <p className="text-xs text-slate-500">Match each value to a home in the app. Leave blank for labels that are not residential homes (e.g. REMOTE, ADMINISTRATION) — those people will have no home access until you choose one in the next step.</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            {parsed.file_homes.map((fh) => (
              <label key={fh} className="flex items-center justify-between gap-3 text-sm border border-slate-200 rounded-md px-3 py-2" data-testid={`home-alias-${fh.replace(/\s+/g, "-")}`}>
                <span className="font-medium text-slate-800">{fh}</span>
                <select value={aliases[fh] || ""} onChange={(e) => setAliases({ ...aliases, [fh]: e.target.value })} className={SEL} data-testid={`home-alias-select-${fh.replace(/\s+/g, "-")}`}>
                  <option value="">— not a home / decide later —</option>
                  {parsed.known_homes.map((k) => <option key={k} value={k}>{k}</option>)}
                </select>
              </label>
            ))}
          </div>
        </div>
      )}

      <div className="flex justify-between">
        <button onClick={onBack} className="px-4 py-2 text-sm rounded-md border border-slate-200" data-testid="mapping-back">Back</button>
        <button onClick={onNext} disabled={!hasEmail || busy} className="px-4 py-2 text-sm rounded-md bg-sky-700 text-white disabled:opacity-50" data-testid="mapping-next">{busy ? "Comparing…" : "Preview changes"}</button>
      </div>
    </div>
  );
};
